export let RESPONSIVE_GRID_SCREEN_SIZE = /*#__PURE__*/function (RESPONSIVE_GRID_SCREEN_SIZE) {
  RESPONSIVE_GRID_SCREEN_SIZE["xs"] = "xs";
  RESPONSIVE_GRID_SCREEN_SIZE["sm"] = "sm";
  RESPONSIVE_GRID_SCREEN_SIZE["md"] = "md";
  RESPONSIVE_GRID_SCREEN_SIZE["lg"] = "lg";
  RESPONSIVE_GRID_SCREEN_SIZE["xl"] = "xl";
  return RESPONSIVE_GRID_SCREEN_SIZE;
}({});